export default __webpack_public_path__ + "static/media/dashboard-analytics-large.34a90ab8.png";